import camelcaseToKebabcase from './camelcase-to-kebabcase';

export default function propsToClassName(props, componentName, modifiers) {
  return modifiers.reduce((className, currentModifier) => (
    `${className}${props[currentModifier] ? ` ${componentName}--${camelcaseToKebabcase(currentModifier)}` : ''}`
  ), componentName);
}
